import GroceryQualityCheckTable from 'components/GroceryQualityCheck';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const GroceryQualityCheck = () => {
  const permissions = useSelector(
    (state: any) => state?.userProfile?.data?.permissions,
  );
  const canView = checkPermission(permissions, {
    permissionName: 'GroceryQualityCheck',
    permission: ['view', 'viewAll'],
  });
  return <div>{canView && <GroceryQualityCheckTable />}</div>;
};
